function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from "@apollo/client";
import { createContext, useMemo } from "react";
import { getUserIDForThirdParties } from "@oui/lib/src/getUserIDForThirdParties";
import { APP_SLUG, IS_PRODUCTION } from "../constants";
import { CurrentUserQuery } from "../hooks/useCurrentUser.query";
import { useIsLoggedIn } from "../hooks/useIsLoggedIn";
import { setUser, setUserProperties } from "../lib/log";
export var CurrentUserContext = /*#__PURE__*/ createContext({}); // eslint-disable-line
/**
 * Loads information about the current user from the API and provides it via
 * React Context to children.
 *
 * Upon loading a user, sets user properties for analytics purposes.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-78}
 */ export function CurrentUserProvider(param) {
    var children = param.children;
    var isLoggedIn = useIsLoggedIn();
    var _useQuery = useQuery(CurrentUserQuery, {
        skip: !isLoggedIn
    }), data = _useQuery.data, rest = _object_without_properties(_useQuery, [
        "data"
    ]);
    var value = useMemo(function() {
        var _data_user;
        var user = data === null || data === void 0 ? void 0 : data.user;
        var email = user === null || user === void 0 ? void 0 : user.email;
        if (user) {
            var claims = user.attributes;
            setUserProperties({
                testUser: (claims === null || claims === void 0 ? void 0 : claims.testUser) || (email === null || email === void 0 ? void 0 : email.includes('detox+'))
            });
        }
        setUser({
            userID: user ? getUserIDForThirdParties({
                userID: user.ID,
                username: user.username,
                createdAt: user.createdAt
            }) : undefined,
            email: IS_PRODUCTION && APP_SLUG !== 'oui-aviva-staff' ? undefined : email
        });
        if (isLoggedIn && (user === null || user === void 0 ? void 0 : user.role)) {
            var _user_role_productConfig;
            setUserProperties({
                // productVariant is a deprecated property that we are sending for legacy purposes.
                // productSlug should be used for creation of new charts / analyses going forward
                productVariant: user.role.product.slug,
                productSlug: user.role.product.slug,
                productStatic: user.role.productStatic,
                roleID: user.role.ID
            });
            if (((_user_role_productConfig = user.role.productConfig) === null || _user_role_productConfig === void 0 ? void 0 : _user_role_productConfig.__typename) === 'RoleAvivaConfig') {
                setUserProperties({
                    productVersion: user.role.productConfig.productVersion,
                    onboardingVariant: user.role.productConfig.onboardingVariant
                });
            }
        }
        return _object_spread_props(_object_spread({
            data: data
        }, rest), {
            loading: rest.loading && !(data === null || data === void 0 ? void 0 : data.user),
            isAdmin: !!(data === null || data === void 0 ? void 0 : (_data_user = data.user) === null || _data_user === void 0 ? void 0 : _data_user.attributes.admin),
            isLoggedIn: isLoggedIn && !!(data === null || data === void 0 ? void 0 : data.user)
        });
    }, [
        data,
        rest,
        isLoggedIn
    ]);
    return /*#__PURE__*/ _jsx(CurrentUserContext.Provider, {
        value: value,
        children: children
    });
}
